import MarkerClusterer, { MarkerClustererOptions } from '@google/markerclustererplus'
import { pluck } from 'ramda'
import { merge, SubscriptionLike } from 'rxjs'

import { clustererDefaults } from '@app-config'
import { InfoWindowMarker } from '@app-types'

export class ClusteredMap {

    public readonly googleMapsInstance: google.maps.Map
    private readonly clusterer: MarkerClusterer

    private markerClickHandler$: SubscriptionLike | undefined

    constructor(
        private readonly element: HTMLElement,
        private readonly mapOptions: google.maps.MapOptions,
        private readonly clustererOptions: MarkerClustererOptions = clustererDefaults,
    ) {
        this.googleMapsInstance = new google.maps.Map(element, mapOptions)
        this.clusterer = new MarkerClusterer(this.googleMapsInstance, [], this.clustererOptions)
    }

    public setMarkers(markers: InfoWindowMarker[]): void {
        this.clusterer.clearMarkers()
        this.clusterer.addMarkers(pluck('marker', markers))
        if (markers.length) {
            this.fitMarkers(markers)
        } else {
            this.googleMapsInstance.setZoom(2)
        }

        if (markers.length === 1) {
            this.googleMapsInstance.setZoom(10)
        }

        this.markerClickHandler$ = merge(...pluck('clicks$', markers)).subscribe((clickedMarker) => {
            markers.forEach((marker) => marker.hideWindow())
            clickedMarker.showWindow()
        })
    }

    public deleteMarkers() {
        this.clusterer.clearMarkers()
        this.markerClickHandler$?.unsubscribe()
    }

    private fitMarkers(markers: InfoWindowMarker[]): void {
        const bounds = new google.maps.LatLngBounds()
        markers.forEach((marker) => bounds.extend(marker.marker.getPosition()!))
        this.googleMapsInstance.fitBounds(bounds, 10)
    }
}
